import { findCommercialEvaluationsByCriteria } from '@src/main/modules/reports/commercial/application/use-cases/find-commercial-evaluations-by-criteria.usecase';
import { createCommercialEvaluationHttpRepository } from '@src/main/modules/reports/commercial/infrastructure/repository/CommercialEvaluationHttpRepository';
import {
  BriefCommercialEvaluation,
  EvaluationCriteria,
} from '@src/main/modules/reports/shared/domain/evaluation.interface';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useDetailedCommercialEvaluations = (criteria: EvaluationCriteria) => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(
    () => (user?.token ? createCommercialEvaluationHttpRepository(tokenProvider) : null),
    [tokenProvider, user?.token],
  );

  return useQuery<BriefCommercialEvaluation[], Error>({
    queryKey: ['commercialDetailedEvaluations', JSON.stringify(criteria)],
    queryFn: async () => {
      if (!repository) return [];
      const response = await findCommercialEvaluationsByCriteria(repository, criteria);
      return response.items;
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });
};
